import React from 'react';
import { WIDGET_TYPES } from '@src/utils/kpi';
import { useSelector } from 'react-redux';
import { widgetsSelector } from '@store/overviewDashboard/base/selectors';
import { Footer } from '@components/common';
import DimensionContainer from './dimension-container';
import { AudienceMetricsWidget, SPIWidget, SubOpportunities } from './metrics-container';
import { ExperienceDashboardWrapper, OverviewWrapper } from './styled';

const widgetComponentMap = {
  [WIDGET_TYPES.audienceMetrics]: AudienceMetricsWidget,
  [WIDGET_TYPES.spi]: SPIWidget,
  [WIDGET_TYPES.subOpportunities]: SubOpportunities,
  [WIDGET_TYPES.dimensionTable]: DimensionContainer,
};

const OverviewDashboard = (props) => {
  // iterate through widgets and render components dynamically
  const widgetsList = useSelector(widgetsSelector);

  const renderWidgetComponent = (widget, index) => {
    const WC = widgetComponentMap[widget.type];
    return (
      <WC
        key={`${widget.type}-${index}`}
        config={widget.config}
        widgetIndex={index}
        currentShareId={props.currentShareId}
        pageType={props.pageType}
      />
    );
  };

  return (
    <ExperienceDashboardWrapper>
      <OverviewWrapper>
        {widgetsList.map((widget, index) =>
          widget.type in widgetComponentMap ? renderWidgetComponent(widget, index) : null,
        )}
      </OverviewWrapper>
      <Footer overrideStyle={{ flexGrow: 1, margin: '0 2.5px', width: 'calc(100% - 5px)' }} />
    </ExperienceDashboardWrapper>
  );
};

export default OverviewDashboard;
